export default __webpack_public_path__ + "images/3132a66731036827956f6d14a4fdab40.svg";